import { withChartLayout } from 'components/common';
import Diagnosis from 'components/features/chart/pre-clinical-manager/diagnosis/Diagnosis';

const DiagnosisPage = withChartLayout('Diagnosis')(Diagnosis);
export default DiagnosisPage;
